import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { Loader } from "cxa-components";
import { isExist, isEmpty, getClientConfig } from "cxa-utils";
import Toast from "./common/Toast";
import Popup from "./common/Popup";
import "@fortawesome/fontawesome-free/css/all.min.css";

class PreBoot extends PureComponent {
  static propTypes = {
    setLanguage: PropTypes.func.isRequired,
    loadCustomCss: PropTypes.func.isRequired,
    doLoadClientSettings: PropTypes.func.isRequired,
    localization: PropTypes.object.isRequired,
    login: PropTypes.object.isRequired,
    clientName: PropTypes.string,
    customCss: PropTypes.string,
    client: PropTypes.string,
    customCssError: PropTypes.bool,
    children: PropTypes.node,
    clientSettings: PropTypes.object,
  };

  componentDidMount() {
    const { setLanguage, loadCustomCss, doLoadClientSettings, clientName, customCss } = this.props;

    doLoadClientSettings(this.props);

    if (isEmpty(customCss) && !this.props.customCssError) {
      loadCustomCss(clientName);
    }

    isExist(clientName) && setLanguage();
  }

  componentDidUpdate(prevProps) {
    const { doLoadClientSettings, clientName } = this.props;
    if (clientName !== prevProps.clientName) {
      doLoadClientSettings(this.props);
    }
  }

  render() {
    const {
      localization,
      clientName,
      client,
      customCss,
      customCssError,
      children,
      clientSettings,
    } = this.props;
    const {
      selectedLanguage: { code },
    } = localization;

    if (!code || !clientSettings) {
      return <Loader />;
    }

    const clientConfig = getClientConfig(client);

    return (
      <div>
        <Helmet>
          <title>{clientConfig.title}</title>
          <link rel="shortcut icon" href={clientConfig.favicon} type="image/x-icon" />
          {client && <body data-client={client} />}
          {clientName && customCss && <style type="text/css">{customCss}</style>}
        </Helmet>

        {children}

        <Popup />
        <Toast />
        {/* {customCssError && <Redirect to="/website-maintenance?type=TechnicalError" />} */}
        {customCssError && console.log("loading custom css error")}
      </div>
    );
  }
}

export default PreBoot;



// WEBPACK FOOTER //
// ./components/PreBoot.jsx